<template>
    <div id="app">
        <div class="left" style="margin-top:150px">
            <div id="live_content" class="video_container" style="width: 640px;height: 480px;background: #4C4B4B;border: 1px solid rgb(255, 204, 0);">
                <div style="color:white; text-align:center; margin: 230px 0">等待連線中</div>
            </div>
            <fieldset class="functions" v-show="isConnect">
                <legend style="font-size: 20px; font-weight: bold; margin-left:20px">功能, 經由 {{ AccessType }} 連線</legend>
                <div v-show="isLive">
                    <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="startPlay">開始預覽</v-btn>
                    <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="pausePlay">停止預覽</v-btn><br/>
                    <v-icon :color="isVoiceTriggered?'green':'red'" class="mx-2">{{ isVoiceTriggered?"mdi-volume-high":"mdi-volume-off" }}</v-icon>
                    <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="()=>{
                        isVoiceTriggered = true;
                        clickSetVolume();}">開啟聲音</v-btn>
                    <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="()=>{
                        isVoiceTriggered = false;
                        clickCloseSound(); }">停止聲音</v-btn><br/>
                    <v-icon :color="isAudioTriggered?'green':'red'" class="mx-2">{{ isAudioTriggered?"mdi-account-tie-voice":"mdi-account-tie-voice-off" }}</v-icon>
                    <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="()=>{
                        isAudioTriggered = true;
                        clickStartVoiceTalk(); }">開始語音對講</v-btn>
                    <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="()=>{
                        isAudioTriggered = false;
                        clickStopVoiceTalk(); }">停止語音對講</v-btn>
                </div>
                <div v-show="!isLive">
                    <div class="rowDiv contentCenter mt-1">
                        <v-text-field label="開始時間 (時間格式:2024-01-01 23:59:59)" dense hide-details outlined filled v-model="starttime" color="black" class="mb-2" style="width:350px"></v-text-field>
                        <v-text-field label="結束時間 (時間格式:2024-01-01 23:59:59)" dense hide-details outlined filled v-model="endtime"   color="black" class="mb-2" style="width:350px"></v-text-field>
                    </div>
                    <v-btn depressed color="success" class="btn_fontSize ml-2" @click="clickStartPlayback">開始回放</v-btn>
                    <v-btn depressed color="success" class="btn_fontSize ml-2" @click="clickStopPlayback">停止回放</v-btn>
                    <v-btn depressed color="success" class="btn_fontSize ml-2" @click="clickPause">暫停</v-btn>
                    <v-btn depressed color="success" class="btn_fontSize ml-2" @click="clickResume">恢復</v-btn>
                    <br />
                    <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="clickPlaySlow">慢放</v-btn>
                    <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="clickPlayFast">快放</v-btn>
                    <v-btn depressed color="success" class="btn_fontSize ml-2 my-2" @click="clickStartDownloadRecordByTime">下載</v-btn>
                </div>
            </fieldset>
            
            <fieldset class="login"  v-show="DEBUG.ShowFunction">
                <legend>{{message}}</legend>
                <table cellpadding="0" cellspacing="3" border="0">
                    <tbody>
                        <tr>
                            <td class="tt">IP地址</td>
                            <td><input type="text" class="txt" v-model="loginip"></td>
                            <td class="tt">端口號</td>
                            <td><input type="text" class="txt" v-model="port"></td>
                        </tr>
                        <tr>
                            <td class="tt">帳號</td>
                            <td><input type="text" class="txt" v-model="username"></td>
                            <td class="tt">密碼</td>
                            <td><input type="password" class="txt" v-model="password"></td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <span class="tt cut_screen">窗口分割</span>
                                <select @change="splitVideo" v-model="viewMode">
                                    <option value="1" selected="">1x1</option>
                                    <option value="2">1x2</option>
                                    <option value="3">2x2</option>
                                    <option value="4">3x3</option>
                                    <option value="5">4x4</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4">
                                <input type="button" class="btn" value="启动服务" @click="startService">
                                <input type="button" class="btn" value="登錄" @click="connectVideo">
                                <input type="button" class="btn" value="開始預覽" @click="startPlay">
                                <input type="button" class="btn" value="停止預覽" @click="pausePlay">
                                <input type="button" class="btn" value="退出" @click="disConnectVideo">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>
        </div>
        <div >
            <fieldset class="preview" v-show="DEBUG.ShowFunction">
                <legend>預覽</legend>
                <table cellpadding="0" cellspacing="3" border="0">
                    <tbody>
                        <tr>
                            <td class="tt">碼流類型</td>
                            <td>
                                <select class="sel" v-model="iStream" @change="setStream">
                                    <option value="0">主碼流</option>
                                    <option value="1">副碼流</option>
                                    <option value="2">三碼流</option>
                                </select>
                            </td>

                        </tr>
                        <tr>
                            <td class="tt">音量</td>
                            <td>
                                <input type="text" class="txt" maxlength="3" v-model="volume">&nbsp;<input type="button"
                                    class="btn" value="設置" @click="clickSetVolume">（範圍：0~100）
                            </td>
                            <td>
                                <input type="button" class="btn" value="打開聲音" @click="clickOpenSound">
                                <input type="button" class="btn" value="關閉聲音" @click="clickCloseSound">
                            </td>
                        </tr>
                        <tr>
                            <td class="tt">通道對講</td>
                            <td>
                                <input type="button" class="btn" value="開始對講" @click="clickStartVoiceTalk">
                                <input type="button" class="btn" value="停止對講" @click="clickStopVoiceTalk">
                            </td>
                            <td>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <input id="fullbtn" type="button" class="btn" value="全屏" @click="clickFullScreen">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>
            <fieldset class="playback" v-show="DEBUG.ShowFunction">
                <legend>回放</legend>
                <table width="100%" cellpadding="0" cellspacing="3" border="0">
                    <tbody>
                        <tr>
                            <td class="tt">開始時間</td>
                            <td>
                                <input type="text" class="txt" v-model="starttime">（時間格式：2013-11-11
                                12:34:56）
                            </td>
                        </tr>
                        <tr>
                            <td class="tt">結束時間</td>
                            <td>
                                <input type="text" class="txt" v-model="endtime">
                                <input type="button" class="btn" value="搜索" @click="clickRecordSearch">
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <input type="button" class="btn" value="開始回放" @click="clickStartPlayback">
                                <input type="button" class="btn" value="停止回放" @click="clickStopPlayback">
                                <input type="button" class="btn" value="暫停" @click="clickPause">
                                <input type="button" class="btn" value="恢復" @click="clickResume">
                                <input type="button" class="btn" value="慢放" @click="clickPlaySlow">
                                <input type="button" class="btn" value="快放" @click="clickPlayFast">
                                <input type="button" class="btn" value="下載" @click="clickStartDownloadRecordByTime">
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <div id="searchdiv" class="searchdiv">
                                    <el-table :data="tableData" style="width: 100%" v-if="tableData.length">
                                        <el-table-column prop="channelno" label="通道號" width="100px" align="center">
                                        </el-table-column>
                                        <el-table-column prop="starttime" label="開始時間" width="150px" align="center">
                                        </el-table-column>
                                        <el-table-column prop="endtime" label="結束時間" width="150px" align="center">
                                        </el-table-column>
                                        <el-table-column prop="filename" label="文件名稱" width="350px" align="center">
                                        </el-table-column>
                                        <el-table-column label="操作">
                                            <template slot-scope="scope">
                                                <el-button size="mini" type="danger"
                                                    @click="StartDownLoad(scope.$index, scope.row)">下載
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="tt">按時間下載開始時間</td>
                            <td>
                                <input type="text" class="txt" value="2013-12-10 00:00:00"
                                    v-model="downloadstarttime">（時間格式：2013-11-11 12:34:56）
                            </td>
                        </tr>
                        <tr>
                            <td class="tt">按時間下載結束時間</td>
                            <td>
                                <input type="text" class="txt" v-model="downloadendtime">
                                <input type="button" class="btn" value="下載" @click="clickStartDownloadRecordByTime">
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <input type="button" class="btn" value="本地回放" @click="browseFile">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>
        </div>
        <div class="left"></div>
    </div>
</template>
<script>
// import Service from '../service/service'
export default {
    data: () => ({
        message: '登錄',
        vPlayer: null,
        AccessType: '',
        TryCount: 50,
        username: '',
        password: '',
        loginip: '',
        port: '3000',
        iChanNo: 1,
        iVideoMode: 0,
        iStream: 0, // 0:MainStream, 1:SubStream, 2:lowStream
        viewMode: 1,
        volume: 100,
        starttime: '2023-04-08 00:00:00',
        endtime: '2023-04-11 23:59:59',
        downloadstarttime: '2023-04-16 13:10:14',
        downloadendtime: '2023-04-16 18:22:11',
        tableData: [],
        servicePort: 6628,
        bLocalService: false,
        filename: '',
        isLive: true,
        isConnect: false,
        hInterval: null,
        hIntervalCount: -1,

        isAudioTriggered: false,
        isVoiceTriggered: false,

        documentTitle: '',
        DEBUG: {
            Enabled: false,
            ShowFunction: false,
        }
    }),
    created: function () {
        this.documentTitle = document.title

        // Load Javascript to DOM, then can be found by window.self.VARIABLE
        let crypto = document.createElement('script')
        crypto.setAttribute('src', './external/crypto-js.min.js')
        document.head.appendChild(crypto)

        let moment = document.createElement('script')
        moment.setAttribute('src', './external/moment-with-locales-2.11.2.min.js')
        document.head.appendChild(moment)

        let plugin = document.createElement('script')
        plugin.setAttribute('src', './utils/plugin.min.js')
        //plugin.setAttribute('src', './utils/plugin.js')
        document.head.appendChild(plugin)

        let jquery = document.createElement('script')
        jquery.setAttribute('src', './external/jquery-3.5.1.min.js')
        document.head.appendChild(jquery)

        let protocol = document.createElement('script')
        protocol.setAttribute('src', './external/custom-protocol-check.min.js')
        document.head.appendChild(protocol)

        this.$emit('setAppbar', { isHide: true })
    },
    mounted() {
        var _this = this
        window.addEventListener('beforeunload', function() {
            _this.clickCloseSound()
            _this.clickStopVoiceTalk()

            if (_this.isLive) {
                _this.pausePlay()
            }
            else {
                _this.clickStopPlayback()
            }
            _this.disConnectVideo()
        })
        window.addEventListener('reload', function() {
            _this.clickCloseSound()
            _this.clickStopVoiceTalk()

            if (_this.isLive) {
                _this.pausePlay()
            }
            else {
                _this.clickStopPlayback()
            }
            _this.disConnectVideo()
        })

        this.AccessType = this.$store.getters.getAccessType
        var storeParam = this.$store.getters.getRouteParam
        this.loginip = storeParam[0]
        this.username = storeParam[1]
        this.password = storeParam[2]
        this.port = storeParam[3]
        this.isLive = storeParam[4] == 1
        if (storeParam.length == 7) {
            this.starttime  = storeParam[5].replace('T', ' ')
            this.endtime    = storeParam[6].replace('T', ' ')
            this.downloadstarttime  = storeParam[5].replace('T', ' ')
            this.downloadendtime    = storeParam[6].replace('T', ' ')
        }
        // 移除參數
        this.$store.commit('setRouteParam', [])
        this.$store.commit('setAccessType', '')

        // 等待連線後，自行撥放
        this.hInterval = setInterval(() => {

            if (this.AccessType == 'LocalDevice') {
                if (this.TryCount < 0) {
                    clearInterval(this.hInterval)
                    alert('!!LocalDevice unavailable!!')
                    return;
                }
                this.TryCount = this.TryCount -1;
            }

            // 等待 DOM 完成
            if (this.hIntervalCount == -1) {
                // 設定顯示區塊
                this.vPlayer = window.self._VideoFactory.GetVideo('live_content', 4, 4, 'video', { servicePort: 6628 });
                window.self._vPlayer = this.vPlayer
                this.vPlayer.SetVideoInfo(this.vPlayer.GetCurViewIdx(), this.iChanNo, this.iStream, this.iVideoMode);
                // this.vPlayer.SetAlert(function(msg){this.showAlert("error",msg)});
                
                {
                    let _self = this;
                    let aUrl = ['127.', '0.', '0.', '1'];
                    let sUrl = aUrl[0] + aUrl[1] + aUrl[2] + aUrl[3];
                    let oWebSocket = new WebSocket("ws://" + sUrl + ":" + _self.servicePort);
                    if (oWebSocket) {
                        oWebSocket.onopen = function () {
                            _self.bLocalService = true;
                            console.log('new localservice websocket port:' + _self.servicePort + ' succeed!');
                        };
                        oWebSocket.onerror = function () {
                            oWebSocket.close();
                            oWebSocket = null;
                            console.log('new localservice websocket port:' + _self.servicePort + ' failed!');
                            _self.startService()
                        };
                    }

                    // 啟動服務
                    // this.startService()

                    this.hIntervalCount = 0
                    if (this.DEBUG.Enabled) console.log(document.title)
                    console.log('Display Init')
                }
                
                return
            }

            if (!this.vPlayer) { 
                if (this.DEBUG.Enabled) console.log(document.title)
                console.log('Wait for Display Initialed')
                return
            }

            if (!this.bLocalService) {
                if (this.DEBUG.Enabled) console.log(document.title)
                console.log('Wait for Service Initialed')
                return
            }
            
            if (this.hIntervalCount == 0) {
                // Connect function will takes about 60~70 sec. when unconnectable
                this.vPlayer.Connect(this.loginip, this.username, this.password, parseInt(this.port, 10));
                this.hIntervalCount = 1
                if (this.DEBUG.Enabled) console.log(document.title)
                console.log('first Connect')
                return
            }

            this.isConnect = this.vPlayer.loginid > -1
            document.title = this.documentTitle
            if (this.DEBUG.Enabled) console.log(document.title)
            console.log('Connected:' + this.isConnect)
            
            if (!this.isConnect) {
                this.hIntervalCount += 1

                if (this.hIntervalCount > 500) {
                    clearInterval(this.hInterval)
                    alert('!!Device unavailable!!')
                    return
                }

                return
            }

            console.log('Connected:' + this.isConnect)
            
            setTimeout(() => {
                document.title = this.documentTitle
                if (this.DEBUG.Enabled) console.log(document.title)
                console.log('try play')
                if (this.isLive) {
                    this.vPlayer.Live(this.vPlayer.GetCurViewIdx())
                } else {
                    console.log(this.iChanNo, this.iStream+1, this.starttime, this.endtime)
                    this.vPlayer.StartPlayBackByTime(this.iChanNo, this.iStream+1, this.starttime, this.endtime);
                    this.vPlayer.onPlayBack = function (idx, chnNo) {
                        console.log("idx:" + idx + "chnNo:" + chnNo);
                    }
                }
            }, 2000)

            clearInterval(this.hInterval)
        }, 200)
    },
    methods: {
        showWaiting (isWaiting, msgWaiting) {
            this.$emit('setWaiting', { mWaiting: 1, isWaiting: isWaiting, msgWaiting: msgWaiting })
        },
        showAlert (type, message) {
            var alert = {
                alertType: null,
                alertMessage: '',
                alertIcon: null
            }
            if (type === 'success') {
                alert.alertType = 'success'
                alert.alertIcon = 'mdi-check-circle'
            } else {
                alert.alertType = 'error'
                alert.alertIcon = 'mdi-alert-circle'
            }
            alert.alertMessage = message
            this.$emit('setAlert', alert)
        },
        startService: function () {
            var _self = this;
            var sRegName = 'mbsshinsoft:\\';
            // var _this = this;
            window.customProtocolCheck(sRegName,
                function () {
                    console.log('window.customProtocolCheck start MultiBrowserService failed or does not exist!');
                },
                function () {
                    console.log('window.customProtocolCheck start MultiBrowserService succeed!');
                    var aUrl = ['127.', '0.', '0.', '1'];
                    var sUrl = aUrl[0] + aUrl[1] + aUrl[2] + aUrl[3];
                    var oWebSocket = new WebSocket("ws://" + sUrl + ":" + _self.servicePort);
                    if (oWebSocket) {
                        oWebSocket.onopen = function () {
                            _self.bLocalService = true;
                            console.log('new localservice websocket port:' + _self.servicePort + ' succeed!');
                        };
                        oWebSocket.onerror = function () {
                            oWebSocket.close();
                            oWebSocket = null;
                            console.log('new localservice websocket port:' + _self.servicePort + ' failed!');
                        };
                    }
                }, 30000,
                function () {
                    console.log('The browser does not support window.customProtocolCheck!');
                }
            );
        },
        connectVideo: function () {
            this.vPlayer.Connect(this.loginip, this.username, this.password, parseInt(this.port, 10));
        },
        disConnectVideo: function () {
            this.vPlayer.Logout();
        },
        startPlay: function () {
            this.vPlayer.Live(this.vPlayer.GetCurViewIdx());
        },
        pausePlay: function () {
            this.vPlayer.Stop(this.vPlayer.GetCurViewIdx());
        },
        splitVideo: function () {
            switch (this.viewMode) {
                case '1':
                    this.vPlayer.SetViewMode(1, 1);
                    break;
                case '2':
                    this.vPlayer.SetViewMode(1, 2);
                    break;
                case '3':
                    this.vPlayer.SetViewMode(2, 2);
                    break;
                case '4':
                    this.vPlayer.SetViewMode(3, 3);
                    break;
                case '5':
                    this.vPlayer.SetViewMode(4, 4);
                    break;
                default:
                    break;
            }

        },
        setStream: function () {
            var iViewIdx = this.vPlayer.GetCurViewIdx();
            this.vPlayer.SetVideoInfo(iViewIdx, this.iChanNo, this.iStream);
            this.vPlayer.Live(iViewIdx, this.iStream);
        },
        clickSetVolume: function () {
            this.vPlayer.AudioEnable(1);
            this.vPlayer.SetVolume(parseInt(this.volume, 10));
        },
        clickOpenSound: function () {
            this.vPlayer.AudioEnable(1);
        },
        clickCloseSound: function () {
            this.vPlayer.AudioEnable(0);
        },
        clickStartVoiceTalk: function () {
            this.vPlayer.VoiceTalk(1);
        },
        clickStopVoiceTalk: function () {
            this.vPlayer.VoiceTalk(0);
        },
        clickFullScreen: function () {
            this.vPlayer.FullScreen();
        },
        clickStartPlayback: function () {
            this.vPlayer.StartPlayBackByTime(this.iChanNo, 1, this.starttime, this.endtime);
            this.vPlayer.onPlayBack = function (idx, chnNo) {
                console.log("idx:" + idx + "chnNo:" + chnNo);
            }
        },
        clickStopPlayback: function () {
            this.vPlayer.Stop(this.vPlayer.GetCurViewIdx());
        },
        clickPause: function () {
            this.vPlayer.PlaybackDisplay(1);
        },
        clickResume: function () {
            this.vPlayer.PlaybackDisplay(0);
        },
        clickPlaySlow: function () {
            this.vPlayer.PlaySpeed(-2);
        },
        clickPlayFast: function () {
            this.vPlayer.PlaySpeed(2);
        },
        browseFile: function () {
            window.self.SDK_OBJ.ShowFileDialog(this.vPlayer)
        },
        clickStartDownloadRecordByTime: function () {
            var _this = this
            _this.showWaiting(true, '開始下載')
            this.filename = this.downloadstarttime.replaceAll('-','').replaceAll(':','')
            this.vPlayer.StartRemoteClip(this.filename, this.iChanNo - 1, parseInt(this.iStream), this.downloadstarttime, this.downloadendtime, 0);
            this.vPlayer.OnVideoEdit = function (sender, value) {
                console.log(sender)
                console.log(value)
                _this.showWaiting(true, '下載完成')
                setTimeout(() => {
                    _this.showWaiting(false, '')
                }, 2000);
            }
        },
        clickRecordSearch: function () {
            var _self = this;
            var searchRecorList = [
                0, //通道號
                0, //碼流號 0-主碼流 1-副碼流
                1, //查询類型 远程或本地
                1, //文件類型 1-錄影 2-圖片
                255, //錄影類型 1-手动 2-定時 3-报警 255-全部
                this.starttime, //開始時間
                this.endtime, //結束時間
                5, //页大小
                0 //页碼
            ]
            this.vPlayer.FileQuery(searchRecorList);
            this.vPlayer.onSearchResult = function (sender, value, total) {
                console.log(sender)
                console.log(total)
                _self.tableData = value;
            }
        },
        StartDownLoad: function (index, row) {
            var _self = this;
            _self.vPlayer.StartDownLoad(row.filename, this.filename, 0, 0);
            _self.vPlayer.onDownload = function (sender, value) {
                console.log(sender)
                console.log(value)
                alert('下載完成')
            }
        }
    }
}
</script>
